<template>
  <div id="staff-list" class="pa-4">
    <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
      <add-sma-online-payment
        pageDescription="Add SMA Online Payment"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt"
        v-if="addRecordPrompt"
      ></add-sma-online-payment>
    </v-dialog>

    <!-- Header Banner -->
    <div class="banner-header">
      <div class="banner-circle banner-circle-1"></div>
      <div class="banner-circle banner-circle-2"></div>
      <div class="banner-title">
        <h1 class="page-title">{{ PageTitle }}</h1>
        <p
          class="mt-2 mb-0"
          style="
            color: rgba(255, 255, 255, 0.9);
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0.3px;
          "
        >
          View and manage senior members list
        </p>
      </div>
      <v-btn fab class="refresh-btn" @click="refreshPageData()" elevation="0">
        <v-icon size="28">mdi-refresh</v-icon>
      </v-btn>
    </div>

    <!-- Loading Spinner -->
    <div class="d-flex justify-content-center mb-6" v-if="LoadingFlag">
      <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
    </div>

    <!-- Search Form -->
    <v-card class="search-card" v-if="SearchFormFlag">
      <v-card-text>
        <v-form ref="form2" v-model="valid1" lazy-validation>
          <v-row wrap class="align-center">
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-calendar-range</v-icon>
                <span class="text-danger mr-1">*</span> From Date
              </div>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    required
                    v-model="FromDate"
                    placeholder="Select From Date"
                    readonly
                    v-on="on"
                    background-color="#FFFFFF"
                    validate-on-blur
                    dense
                    outlined
                    hide-details
                    class="rounded-lg"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="FromDate"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-calendar-range</v-icon>
                <span class="text-danger mr-1">*</span> To Date
              </div>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    required
                    v-model="ToDate"
                    placeholder="Select To Date"
                    readonly
                    v-on="on"
                    background-color="#FFFFFF"
                    validate-on-blur
                    dense
                    outlined
                    hide-details
                    class="rounded-lg"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ToDate"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-map-marker-outline</v-icon>
                Zone <small>(Optional)</small>
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="ZoneCodeOptions"
                :rules="ZoneCodeRules"
                :loading="ZoneCodeOptionsLoading"
                v-model="ZoneCode"
                placeholder="Select zone"
                dense
                clearable
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-map-outline</v-icon>
                Regional <small>(Optional)</small>
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="RegionCodeOptions"
                :rules="RegionCodeRules"
                :loading="RegionCodeOptionsLoading"
                v-model="RegionCode"
                placeholder="Choose Region"
                dense
                clearable
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-account-group-outline</v-icon>
                LO <small>(Optional)</small>
              </div>
              <v-autocomplete
                :reduce="(option) => option.value"
                v-model="LomCode"
                :rules="LomCodeRules"
                :items="LomCodeOptions"
                :loading="LomCodeOptionsLoading"
                placeholder="Select LO"
                dense
                clearable
                outlined
                hide-details
                background-color="#FFFFFF"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="input-label">
                <v-icon>mdi-credit-card-outline</v-icon>
                Payment Id <small>(Optional)</small>
              </div>
              <div class="d-flex align-center">
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  placeholder="Enter Payment Id"
                  dense
                  outlined
                  hide-details
                  background-color="#FFFFFF"
                  class="rounded-lg flex-grow-1"
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" sm="6" lg="2" md="2">
              <div class="input-label" style="visibility: hidden">&nbsp;</div>
              <v-btn
                :disabled="!valid1"
                @click.prevent="searchForm"
                :loading="SearchFlag"
                class="search-btn"
                style="min-width: 130px; font-size: 16px; height: 40px"
              >
                <v-icon left size="20" color="white">mdi-magnify</v-icon>
                Search
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-2 px-3">
            <v-col
              cols="12"
              class="d-flex justify-md-end justify-center flex-wrap pa-0"
            >
              <v-btn
                v-if="RoleId == 2"
                @click.prevent="addRecordPrompt = true"
                color="#0097D7"
                elevation="0"
                class="rounded-lg text-white mr-3 mb-3"
                style="height: 44px; font-weight: 600; text-transform: none"
              >
                <v-icon left>mdi-plus-circle-outline</v-icon>
                Add Online Payment
              </v-btn>
              <v-btn
                v-if="ExcelDownloadFlag"
                color="#3A67B1"
                @click.prevent="
                  generateExcel(
                    rows,
                    ExcelFields,
                    ExcelFileName,
                    'My Worksheet'
                  )
                "
                elevation="2"
                class="rounded-lg text-white font-weight-bold mb-3"
                style="
                  height: 44px;
                  text-transform: none;
                  transition: background-color 0.3s ease;
                "
              >
                <v-icon left dark color="white">mdi-download</v-icon> Download
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Empty State -->
    <div class="text-center py-10" v-if="ResultFlag && rows.length == 0">
      <h4 class="text-muted font-weight-bold">No records found.</h4>
    </div>

    <!-- Results Table -->
    <v-card
      class="result-card elevation-4 rounded-xl border-0"
      v-if="rows.length > 0"
    >
      <v-card-title
        class="px-6 pt-6 pb-2 d-flex justify-space-between align-center flex-wrap"
      >
        <div>
          <h3 class="mb-0 text-h6 font-weight-bold" style="color: #0a0f29">
            {{ rows.length }} records found
          </h3>
        </div>
        <div class="d-flex align-center">
          <v-btn
            v-if="rows.length > 0 && ZoneCode"
            :disabled="selected.length === 0"
            @click.prevent="bulkUpdateRegionPrompt = true"
            color="#707490"
            elevation="0"
            class="rounded-lg text-white ml-3"
            style="height: 40px; font-weight: 600; text-transform: none"
          >
            <v-icon left>mdi-map-marker</v-icon>
            Region Bulk Update
          </v-btn>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search records here"
            single-line
            hide-details
            outlined
            dense
            class="rounded-lg ml-3"
            style="
              max-width: 300px;
              background-color: #ffffff;
              border: 1px solid #0097d7;
            "
          ></v-text-field>
        </div>
      </v-card-title>
      <v-card-text class="pa-2 px-md-4">
        <v-data-table
          class="custom-table elevation-0"
          loading-text="Loading... Please wait"
          v-model="selected"
          :search="search"
          :show-select="tableOptions1.ShowSelectFlag"
          :loading="TableLoadingFlag"
          :item-key="tableOptions1.ItemKey"
          :single-select="tableOptions1.SingleSelectFlag"
          :headers="tableColumns1"
          :items="rows"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <template v-slot:[`item.ActiveStatusTxt`]="{ item }">
            <v-chip
              :color="getActiveStatusColor(item.ActiveStatusTxt)"
              small
              class="font-weight-medium"
              dark
              >{{ item.ActiveStatusTxt }}</v-chip
            >
          </template>

          <template v-slot:[`item.ProfilePic`]="{ item }">
            <v-avatar size="48" class="my-2 elevation-1">
              <img :src="item.ProfilePic" alt="Profile" />
            </v-avatar>
          </template>

          <template v-slot:[`item.RegionName`]="{ item }">
            <span v-if="item.RegionName">{{ item.RegionName }}</span>
            <span v-else style="color: #414042; font-weight: 600">NA</span>
          </template>

          <template v-slot:[`header.OrderTypeTxt`]>
            <div class="d-flex flex-column py-1">
              <span style="line-height: 1.2">ORDER TYPE</span>
              <span
                style="
                  font-size: 11px;
                  color: #ffffff;
                  font-weight: normal;
                  margin-top: 2px;
                  line-height: 1.2;
                "
                >CATEGORY NAME</span
              >
            </div>
          </template>

          <template v-slot:[`item.ZoneLomTxt`]="{ item }">
            <div class="d-flex flex-column py-2" style="max-width: 200px">
              <span
                class="font-weight-bold"
                style="color: #0a0f29; font-size: 13px; white-space: normal"
                >{{ item.ZoneName }}</span
              >
              <span
                class="mt-1"
                style="color: #414042; font-size: 12px; white-space: normal"
                >{{ item.LomName }}</span
              >
            </div>
          </template>

          <template v-slot:[`item.MemberDetailsTxt`]="{ item }">
            <div class="d-flex flex-column py-2" style="max-width: 180px">
              <span
                class="font-weight-bold"
                style="color: #0a0f29; font-size: 13px; white-space: normal"
                >{{ item.MemberName }}</span
              >
              <span
                class="mt-1"
                style="color: #414042; font-size: 12px; white-space: normal"
                >{{ item.MembershipId }}</span
              >
            </div>
          </template>

          <template v-slot:[`item.ContactTxt`]="{ item }">
            <div class="d-flex flex-column py-2" style="max-width: 200px">
              <span
                class="font-weight-bold"
                style="color: #0a0f29; font-size: 12px; white-space: normal"
                >{{ item.MobileNo }}</span
              >
              <span
                class="mt-1"
                style="
                  color: #414042;
                  font-size: 11px;
                  white-space: normal;
                  word-break: break-all;
                "
                >{{ item.EmailId }}</span
              >
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div
              class="d-flex align-center"
              style="min-width: 140px; white-space: nowrap"
            >
              <v-tooltip bottom v-if="item.ChangeLomFlag && AdminFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="mr-1 bg-light-warning"
                    @click="editAlert(item, e)"
                    v-bind="attrs"
                    r
                    v-on="on"
                  >
                    <v-icon size="20" color="#EDBE38"
                      >mdi-file-document-edit</v-icon
                    >
                  </v-btn>
                </template>
                <span>Change Member LO</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.ChangeRegionFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="mr-1 bg-light-success"
                    @click="editRegionAlert(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="20" color="#56BDA3">mdi-map-marker</v-icon>
                  </v-btn>
                </template>
                <span>Change Member Regional</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.EditMemberFlag && AdminFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="mr-1 bg-light-purple"
                    @click="editMemberAlert(item, e)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="20" color="#0097D7">mdi-account-edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit Member Details</span>
              </v-tooltip>
              <v-tooltip bottom v-if="AdminFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="mr-1 bg-light-error"
                    @click="deleteAlert(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="20" color="#FF5252">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete Record</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.OrdersReceiptPath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="item.OrdersReceiptPath"
                    target="_blank"
                    icon
                    small
                    class="bg-light-error"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="20" color="#414042">mdi-file-pdf</v-icon>
                  </v-btn>
                </template>
                <span>Download Receipt</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialogs -->
    <v-dialog v-model="editRecordPrompt" persistent max-width="1200px">
      <senior-member-edit
        :editRecordPrompt="editRecordPrompt"
        :recordData="recordData"
        @hideEditRecordPrompt="hideEditRecordPrompt"
        v-if="editRecordPrompt"
      ></senior-member-edit>
    </v-dialog>

    <v-dialog v-model="editRegionRecordPrompt" persistent max-width="1200px">
      <senior-members-region-edit
        :EditRecordPrompt="editRegionRecordPrompt"
        :recordData="recordData"
        :listZoneCode="ZoneCode"
        @hideEditRecordPrompt="hideEditRegionRecordPrompt"
        v-if="editRegionRecordPrompt"
      ></senior-members-region-edit>
    </v-dialog>

    <v-dialog v-model="membereditRecordPrompt" max-width="70%">
      <member-edit
        pageDescription="Edit Member Details"
        :editRecordPrompt="membereditRecordPrompt"
        @hideEditRecordPrompt="memberhideEditRecordPrompt"
        :recordIndex="memberId"
        v-if="membereditRecordPrompt"
      ></member-edit>
    </v-dialog>

    <v-dialog v-model="bulkUpdateRegionPrompt" persistent max-width="1200px">
      <bulk-update-region
        pageDescription="Bulk Update Region"
        :bulkUpdateRegionPrompt="bulkUpdateRegionPrompt"
        :listZoneCode="ZoneCode"
        :recordData="recordData"
        :selectedRecords="selected"
        @hideBulkUpdateRegionRecordPrompt="hideBulkUpdateRegionRecordPrompt"
        v-if="bulkUpdateRegionPrompt"
      ></bulk-update-region>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import Swal from "sweetalert2";
import companyConfig from "@/company_config.json";
import AddSmaOnlinePayment from "@/view/pages/erp/seniors/AddSmaOnlinePayment.vue";
import SeniorMemberEdit from "@/view/pages/erp/seniors/SeniorMemberEdit.vue";
import SeniorMembersRegionEdit from "@/view/pages/erp/seniors/SeniorMembersRegionEdit.vue";
import MemberEdit from "@/view/pages/members/MemberEdit.vue";
import BulkUpdateRegion from "@/view/pages/erp/seniors/BulkUpdateRegion.vue";

export default {
  mixins: [common],
  components: {
    AddSmaOnlinePayment,
    SeniorMemberEdit,
    SeniorMembersRegionEdit,
    MemberEdit,
    BulkUpdateRegion,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      SearchFormFlag: true,
      DownloadFlag: true,
      TableLoadingFlag: false,

      rows: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      SpeedDialFlag: false,
      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      recordData: {},
      memberId: "",

      addRecordPrompt: false,
      editRecordPrompt: false,
      editRegionRecordPrompt: false,
      membereditRecordPrompt: false,
      previewRecordPrompt: false,
      bulkUpdateRegionPrompt: false,

      ExcelDownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      BulkUpdateFlag: false,

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCodeRules: [],
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      PaymentId: "",
      PaymentIdRules: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
      RoleId: "",
      AdminFlag: false,
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;
        console.log("RoleId=" + RoleId);
        this.AdminFlag =
          RoleId === 1 || RoleId === 2 || RoleId === 4 ? true : false;
        this.getZoneCodeOptions();
      }
    },
    ZoneCodeOptions: function (newVal) {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
      if (newVal && newVal.length === 2 && newVal[0].value === "") {
        this.ZoneCode = newVal[1].value;
      }
    },
    RegionCodeOptions: function (newVal) {
      console.log("watch RegionCodeOptions");
      this.LoadingFlag = false;
      this.RegionCodeOptionsLoading = false;
      if (newVal && newVal.length === 2 && newVal[0].value === "") {
        this.RegionCode = newVal[1].value;
      }
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      this.getRegionCodeOptions();
      this.getLomCodeOptions();
    },
    RegionCode: function () {
      console.log("watch RegionCode");
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      // this.getTableRecords();
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "senior_members",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var CurrentYearId = this.CurrentYearId;
      console.log(", CurrentYearId=" + CurrentYearId);
      this.LoadingFlag = true;
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options-v2";
      var selectbox1_conditions_array = {
        UserInterface: 9,
        YearCode: CurrentYearId,
        NotAvailable: 1,
        AllZones: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getRegionCodeOptions() {
      console.log("getRegionCodeOptions called");
      var CurrentYearId = this.CurrentYearId;
      console.log(", CurrentYearId=" + CurrentYearId);
      this.LoadingFlag = true;
      this.RegionCodeOptionsLoading = true;
      var selectbox1_source = "RegionCode";
      var selectbox1_destination = "RegionCodeOptions";
      var selectbox1_url = "api/jac-region/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        Zone: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.CurrentYearId;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode
      );
      if (YearCode != "" && ZoneCode != "") {
        this.LomCode = "";
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
          AllOption: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    searchForm() {
      console.log("searchForm is called");

      // var validate1 = this.$refs.form2.validate();
      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      var FromDate = this.FromDate;
      var ToDate = this.ToDate;

      if (validate1 && FromDate != "" && ToDate != "") {
        // this.SearchFlag = true;
        this.LoadingFlag = true;
        this.rows = [];
        this.ExcelFileName = "";
        this.ExcelDownloadFlag = false;
        this.BulkUpdateFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/assign/senior-members/list";
        var upload = {
          UserInterface: 2,
          Zone: this.ZoneCode,
          Region: this.RegionCode,
          Lom: this.LomCode,
          FromDate: FromDate,
          ToDate: ToDate,
          PaymentId: this.PaymentId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;
            thisIns.ResultFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.table_content;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              var options = records.TableOptions;
              thisIns.tableOptions1 = options;

              thisIns.toast("success", output);
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.rows = records.TableData;

              thisIns.ExcelDownloadFlag = options.ExcelDownloadFlag;
              thisIns.ExcelFileName = options.ExcelFileName;
              thisIns.ExcelFields = options.ExcelFields;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    editAlert(tr) {
      console.log("editAlert called");
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.recordData = tr;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to edit";
        this.errorMessage(message);
      }
    },
    editRegionAlert(tr) {
      console.log("editRegionAlert called");
      if (tr && Object.keys(tr).length > 0) {
        this.recordData = tr;
        this.editRegionRecordPrompt = true;
      } else {
        this.errorMessage("Kindly select one record to edit");
      }
    },
    editMemberAlert(tr) {
      console.log("editMemberAlert called");
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.memberId = tr.MemberId;
        this.membereditRecordPrompt = true;
      } else {
        var message = "Kindly select one record to edit";
        this.errorMessage(message);
      }
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      console.log({ flag });
      if (flag) {
        this.searchForm();
      }
    },
    hideEditRegionRecordPrompt(flag) {
      console.log("hideEditRegionRecordPrompt called");
      this.editRegionRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    memberhideEditRecordPrompt(flag) {
      console.log("memberhideEditRecordPrompt called");
      this.membereditRecordPrompt = false;
      console.log({ flag });
      if (flag) {
        this.searchForm();
      }
    },
    hideBulkUpdateRegionRecordPrompt(flag) {
      console.log("hideBulkUpdateRegionRecordPrompt called");
      this.bulkUpdateRegionPrompt = false;
      this.selected = [];
      console.log({ flag });
      if (flag) {
        this.searchForm();
      }
    },
    deleteAlert(tr) {
      console.log("deleteAlert called");
      console.log({ tr });
      var n1 = tr && Object.keys(tr).length;
      if (n1 > 0 && tr.SmPaymentId) {
        var htmlTxt = "";
        if (tr.MemberName) {
          htmlTxt += "<br/> Member Name: <b>" + tr.MemberName + "</b>";
        }
        if (tr.PaymentRzrId) {
          htmlTxt += "<br/> Payment Id: <b>" + tr.PaymentRzrId + "</b>";
        }

        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete this senior member payment and receipt?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: "Yes, Delete",
          confirmButtonColor: "#d33",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.LoadingFlag = true;
            var server_url = companyConfig.apiURL;
            var token = this.$session.get("token");
            token = token == (null || undefined) ? 0 : token;
            var delete_url = server_url + "api/assign/senior-members/destroy";
            var upload = {
              UserInterface: 1,
              SmPaymentId: tr.SmPaymentId,
              SmOrderId: tr.SmOrderId,
              YearwiseMembershipId: tr.YearwiseMembershipId,
              MemberId: tr.MemberId,
            };

            const thisIns = this;
            this.$http({
              url: delete_url,
              method: "POST",
              data: upload,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            })
              .then(function (response) {
                thisIns.LoadingFlag = false;
                var flag = response.data.flag;
                var output = response.data.output;

                if (flag == 1 || flag === true) {
                  thisIns.toast("success", output);
                  thisIns.searchForm();
                } else {
                  thisIns.toast("error", output);
                }
              })
              .catch(function (error) {
                console.log("error=" + error);
                thisIns.LoadingFlag = false;
                thisIns.toast("error", "Failed to delete record.");
              });
          }
        });
      } else {
        var message = "Kindly select one valid record to delete";
        this.errorMessage(message);
      }
    },
  },
  beforeMount() {
    var todayDate = new Date().toISOString().slice(0, 10);
    console.log(todayDate);

    this.FromDate = todayDate;
    this.ToDate = todayDate;

    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
#staff-list {
  background-color: transparent;

  .banner-header {
    background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
    box-shadow: 0 10px 25px rgba(58, 103, 177, 0.2);
    position: relative;
    overflow: hidden;
    padding: 2.5rem 3rem;
    border-radius: 20px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-circle {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
    }
    .banner-circle-1 {
      width: 400px;
      height: 400px;
      top: -200px;
      right: -100px;
    }
    .banner-circle-2 {
      width: 250px;
      height: 250px;
      bottom: -100px;
      right: 250px;
    }

    .banner-title {
      position: relative;
      z-index: 1;
      .report-label {
        color: #edbe38;
        font-weight: 700;
        font-size: 0.85rem;
        letter-spacing: 1.5px;
        margin-bottom: 8px;
        text-transform: uppercase;
      }
      .page-title {
        color: #ffffff;
        font-size: 2.25rem;
        font-weight: 700;
        margin: 0;
        letter-spacing: -0.5px;
      }
    }

    .refresh-btn {
      background: rgba(255, 255, 255, 0.15) !important;
      color: #ffffff !important;
      backdrop-filter: blur(8px);
      width: 56px;
      height: 56px;
      position: relative;
      z-index: 1;
      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: rotate(90deg);
        transition: transform 0.4s ease;
      }
      transition: all 0.3s ease;
    }
  }

  .search-card,
  .result-card {
    border-radius: 20px !important;
    box-shadow: 0 10px 40px rgba(10, 15, 41, 0.05) !important;
  }

  .search-card {
    .v-input--is-focused .v-input__slot {
      border-color: #3a67b1 !important;
    }

    .v-input__slot {
      min-height: 44px !important;
    }

    .search-btn {
      background: #edbe38 !important;
      color: #0a0f29 !important;
      font-weight: 700;
      text-transform: none;
      border-radius: 22px !important;
      letter-spacing: 0.5px;
      height: 44px !important;
      border: none !important;
      box-shadow: 0 8px 20px rgba(237, 190, 56, 0.4) !important;
      transition: all 0.3s ease;

      .v-icon {
        opacity: 0.7;
      }

      &:hover {
        background: #edbe38 !important;
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(237, 190, 56, 0.5) !important;
      }
    }

    .reset-btn {
      background-color: #414042 !important;
      color: #ffffff !important;
      border-radius: 10px;
      height: 44px !important;
      width: 44px !important;
      min-width: 44px !important;
      transition: all 0.3s ease;
      &:hover {
        background-color: #0a0f29 !important;
        transform: translateY(-2px);
      }
    }

    .input-label {
      font-size: 0.85rem;
      font-weight: 600;
      color: #414042;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .v-icon {
        font-size: 16px;
        margin-right: 6px;
        color: #0097d7;
      }
      small {
        margin-left: 4px;
        color: #414042;
        font-weight: 400;
      }
    }
  }

  .bg-light-warning {
    background-color: #ffffff !important;
    border: 1px solid #edbe38 !important;
  }
  .bg-light-success {
    background-color: #ffffff !important;
    border: 1px solid #56bda3 !important;
  }
  .bg-light-purple {
    background-color: #ffffff !important;
    border: 1px solid #0097d7 !important;
  }
  .bg-light-error {
    background-color: #ffffff !important;
    border: 1px solid #414042 !important;
  }
  ::v-deep .container,
  ::v-deep .container--fluid {
    max-width: 100% !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  ::v-deep .custom-table {
    border-radius: 12px;
    overflow: hidden;

    th {
      font-weight: 700 !important;
      color: #ffffff !important;
      text-transform: uppercase;
      font-size: 13px !important;
      letter-spacing: 0.5px;
      background-color: #3a67b1 !important;
      border-bottom: 1px solid #3a67b1 !important;
      padding: 12px 8px !important;
      white-space: normal !important;
      vertical-align: middle !important;

      span {
        font-size: 13px !important;
      }
    }
    td {
      border-bottom: 1px solid #3a67b1 !important;
      padding: 8px 8px !important;
    }
    tr:hover {
      background-color: #ffffff !important;
    }
  }

  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
}
</style>
